import { clearUserStorageItems } from '@components/logout/ProfileBadge';
import { useOktaAuth } from '@okta/okta-react';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

import { Environment } from '@/config';
import { useApiEnvStore } from '@utils/api-client';
import { useSearchParams } from 'react-router-dom';

export const LogoutPage = () => {
  const { oktaAuth } = useOktaAuth();
  const { setEnvironment } = useApiEnvStore();

  const [searchParams] = useSearchParams();
  const env = searchParams.get('env');

  useEffect(() => {
    const asyncLogout = async () => {
      const t = await oktaAuth.session.get();
      if (t.userId) {
        clearUserStorageItems();
        datadogRum.stopSessionReplayRecording();
        if (oktaAuth.signOut) {
          await oktaAuth.signOut().then(() => {
            if (env) {
              setEnvironment(env as Environment);
            }
          });
        }
      } else {
        if (env) {
          setEnvironment(env as Environment);
        }
        window.location.href = '/';
      }
    };

    asyncLogout();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oktaAuth]);

  return null;
};
